var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("form-content-loader")
        : _c(
            "div",
            [
              _c("vue-form-json-schema", {
                attrs: {
                  components: _vm.schemaComponents,
                  schema: _vm.schema,
                  "ui-schema": _vm.uiSchema,
                  options: _vm.vfjsOptions,
                },
                on: { "state-change": _vm.handleStateChange },
                model: {
                  value: _vm.model,
                  callback: function ($$v) {
                    _vm.model = $$v
                  },
                  expression: "model",
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }